import apiTool from "./index";

const GET_TAGS_URL = 'result/get-tags/';
const ADD_TAG_URL = 'result/add-tag/';
const GET_TAG_URL = 'result/get-tag/';
const UPDATE_TAG_URL = 'result/update-tag/';
const DELETE_TAG_URL = 'result/delete-tag/';
const GET_RESULTS_URL = 'result/get-results/';
const GET_REPORTS_URL = 'result/get-reports/';

export default {
    getReports() {
        return apiTool.get(GET_REPORTS_URL);
    },
    getResults() {
        return apiTool.get(GET_RESULTS_URL);
    },
    getTags(payload) {
        return apiTool.get(GET_TAGS_URL + payload.full + "/");
    },
    getTag(tag_id) {
        return apiTool.get(GET_TAG_URL + tag_id + '/');
    },
    addTag(payload) {
        return apiTool.post(ADD_TAG_URL, payload);
    },
    updateTag(payload) {
        return apiTool.post(UPDATE_TAG_URL + payload.id + '/', payload);
    },
    deleteTag(question_id) {
        return apiTool.delete(DELETE_TAG_URL + question_id + '/');
    },
}
